import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
  AlertTitle
} from '@mui/material';
import WarningOutlined from '@ant-design/icons/WarningOutlined';

interface SessionExpiredDialogProps {
  open: boolean;
  onConfirm: () => void;
  error?: string;
  isInteractiveLoginAvailable?: boolean;
}

const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({
  open,
  onConfirm,
  error,
  isInteractiveLoginAvailable = true
}) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      aria-labelledby="session-expired-dialog-title"
      aria-describedby="session-expired-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="session-expired-dialog-title" sx={{ pb: 1 }}>
        <Alert severity="warning" variant="outlined" sx={{ border: 'none', pl: 0 }}>
          <AlertTitle sx={{ mb: 0, display: 'flex', alignItems: 'center', gap: 1 }}>
            <WarningOutlined style={{ fontSize: '1.2rem' }} />
            Session Expired
          </AlertTitle>
        </Alert>
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText id="session-expired-dialog-description" sx={{ mb: 2 }}>
          Your session has expired and cannot be automatically renewed. 
          {isInteractiveLoginAvailable 
            ? ' You will be redirected to the login page to sign in again.'
            : ' Please close the application and sign in again.'
          }
        </DialogContentText>
        
        {error && (
          <Alert severity="error" variant="outlined" sx={{ mt: 2 }}>
            <AlertTitle>Additional Information</AlertTitle>
            {error}
          </Alert>
        )}
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color="primary"
          autoFocus
        >
          {isInteractiveLoginAvailable ? 'Go to Login' : 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;
